<!--解决方案-智慧城市-->
<template class="scheme">
  <div style="font-family: Alibaba">
    <!--CP端-->
    <div class="PC_box">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component class="scheme" :is='components.tail'></component>
        </keep-alive>
      </div>

      <!--导航图-->
      <div>
        <el-carousel height="25vw" class='carousel_class'>
          <el-carousel-item v-for='item in solutionList' :key='item.id'>
<!--            <div @click='jump(item)'>-->
              <el-image
                style="width: 100%;height: 25vw"
                v-if='item.fullPathUrl != null'
                :src='item.fullPathUrl'
              />
<!--            </div>-->
          </el-carousel-item>
        </el-carousel>
      </div>

      <!--用户痛点标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameOne }}
          </h1>
          <p>{{ enNameOne }}</p>
        </div>
      </div>
      <!--用户痛点-->
      <el-row  :gutter="20" class="box-width">
        <el-col :lg="6" :md="6" :sm="12" :xs="24"  v-for="item in userPainPoints" :key="item.id">
          <el-card style="margin-bottom: 20px" shadow="hover" :body-style="{ padding: '0px' }" class="painSpot" >
            <el-image
              class="painSpot-img"
              alt="Image Description"
              :src="item.fullPathUrl != null ? item.fullPathUrl : ''"></el-image>
            <div class="text">
              <h4>{{ item.title }}</h4>
              <div v-html="item.content" class="htmlImgSize"></div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <!--方案介绍标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameTwo }}
          </h1>
          <p>{{ enNameTwo }}</p>
        </div>
      </div>
      <!--方案介绍-->
      <el-row :span="24" class="box-width carbon">
        <el-col :md="12" :sm="12" :xs="24">
          <div class="advantage_img" style="margin: 0">
            <el-image
              class="carbon_img"
              :fit='fit'
              v-if='schemeIntroduction.fullPathUrl != null'
              :src='schemeIntroduction.fullPathUrl'
            />
          </div>
        </el-col>
        <el-col :md="12" :sm="12" :xs="24">
          <div>
            <h4 class="scheme_title">{{schemeIntroduction.title}}</h4>
            <div  v-html="schemeIntroduction.content" class="scheme_p"></div>
          </div>
        </el-col>
      </el-row>

      <!--方案架构标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameThree }}
          </h1>
          <p>{{ enNameThree }}</p>
        </div>
      </div>
      <!--方案架构图片-->
       <div class="box-width solution_img">
         <el-image
           alt="Image Description"
           style="width: 100%"
           :src="solutionArchitecture.fullPathUrl != null ? solutionArchitecture.fullPathUrl : ''"></el-image>
       </div>

      <!--方案优势标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameFour }}
          </h1>
          <p>{{ enNameFour }}</p>
        </div>
      </div>
      <!--方案优势-->
      <el-row :gutter="20" class="box-width scheme_advantages">
        <el-col :lg="8" :md="8" :sm="12" :xs="24" v-for="item in solutionAdvantages" :key="item.id">
            <div>
              <ul class="advantages_ul">
                <li>
                  <el-image
                    alt="Image Description"
                    :src="item.fullPathUrl != null ? item.fullPathUrl : ''"></el-image>
                </li>
                <li>
                  <h3>{{ item.title }}</h3>
                  <div v-html="item.content" class="htmlImgSize"></div>
                </li>
              </ul>
            </div>
        </el-col>
      </el-row>

      <!--应用场景标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameFive  }}
          </h1>
          <p>{{ enNameFive }}</p>
        </div>
      </div>
      <!--应用场景-->
      <div>
        <div class="box-width">
          <el-carousel height="360px">
            <el-carousel-item v-for="item in applicationScenarios" :key="item.id">
              <el-row >
                <el-col :md="12" :sm="12" :xs="24">
                  <div class="cases_text">
                    <h3>{{ item.title }}</h3>
                    <div v-html="item.content" class="htmlImgSize"></div>
                  </div>
                </el-col>
                <el-col :md="12" :sm="12" :xs="24">
                  <el-image
                    class="cases_img"
                    alt="Image Description"
                    :src="item.fullPathUrl != null ? item.fullPathUrl : ''"
                    :fit="fit"></el-image>
                </el-col>
              </el-row>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <!--插入尾部-->
      <div>
        <keep-alive>
          <component  :is='components.tail1'></component>
        </keep-alive>
      </div>
    </div>

    <!--手机端-->
    <div class="mobile_box product">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class='paddingS'>
        <!--占位div-->
        <div style='height: 72px'></div>

        <!--主图-->
        <div class="main_img">
          <el-carousel height="200px" class='carousel_class'>
            <el-carousel-item v-for='item in solutionList' :key='item.id'>
              <div>
                <el-image
                  :fit='fit'
                  v-if='item.fullPathUrl != null'
                  :src='item.fullPathUrl'
                />
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <!--用户痛点-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameOne }}
                <span>{{ enNameOne }}</span>
              </h1>
            </div>
            <!--图片-->
            <div  v-for="item in userPainPoints" :key="item.id">
              <div>
                <el-image style="width: 100%" :src="url"></el-image>
              </div>
              <!--内容-->
              <div>
                <h6> <i class="el-icon-position"></i>
                  {{item.title }}
                </h6>
                <div v-html="item.content" class="htmlImgSize"></div>
              </div>
            </div>
          </div>
        </div>

        <!--方案介绍-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameTwo }}
                <span>{{ cnNameTwo }}</span>
              </h1>
            </div>
            <!--内容-->
            <div>
              <div class="advantage_img" style="margin: 0">
                <el-image
                  class="carbon_img"
                  :fit='fit'
                  v-if='schemeIntroduction.fullPathUrl != null'
                  :src='schemeIntroduction.fullPathUrl'
                />
              </div>
              <div>
                <h4 style="font-size: 20px;line-height: 40px;">{{schemeIntroduction.title}}</h4>
                <div v-html="schemeIntroduction.content" class="htmlImgSize"></div>
              </div>
            </div>
          </div>
        </div>
        <!--方案架构-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameThree }}
                <span>{{ enNameThree }}</span>
              </h1>
            </div>
            <el-image
              alt="Image Description"
              style="width: 100%"
              :src="solutionArchitecture.fullPathUrl != null ? solutionArchitecture.fullPathUrl : ''"></el-image>
          </div>
        </div>

        <!--方案优势-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameFour }}
                <span>{{ enNameFour }}</span>
              </h1>
            </div>
            <!--内容-->
            <div>
              <div v-for="item in solutionAdvantages" :key="item.id">
                <h6>
                  <i class="el-icon-position"></i>
                  {{ item.title }}
                </h6>
                <div v-html="item.content" class="htmlImgSize"></div>
              </div>
            </div>
          </div>
        </div>

        <!--应用场景-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                {{ cnNameFive }}
                <span>{{ enNameFive }}</span>
              </h1>
            </div>
            <!--内容-->
            <div v-for="item in applicationScenarios" :key="item.id">
              <!--图片-->
              <div>

                <el-image style="width: 100%"  :src="item.fullPathUrl != null ? item.fullPathUrl : ''"></el-image>
              </div>
              <div>
                <h6>
                  <i class="el-icon-position"></i>
                  {{ item.title }}
                </h6>
                <div v-html="item.content" class="htmlImgSize"></div>
              </div>
            </div>
          </div>
        </div>

        <!--提交需求-->
        <div class="boxs_content">
          <div class='title'>
            <!--标题-->
            <div>
              <h1>
                <i class="el-icon-caret-right"></i>
                提交需求
                <span>Submit Requirements</span>
              </h1>
            </div>
            <!--form表单-->
            <el-form class="el_form" :model="form" ref="solutionRef" :rules="rules">
              <el-form-item prop="unitName">
                <el-input class="consult_inp" placeholder="单位" v-model="form.unitName"></el-input>
              </el-form-item>
              <el-form-item prop="fullName">
                <el-input class="consult_inp" placeholder="姓名" v-model="form.fullName"></el-input>
              </el-form-item>
              <el-form-item prop="phone">
                <el-input class="consult_inp" placeholder="电话" v-model="form.phone"></el-input>
              </el-form-item>
              <el-form-item prop="demand">
                <el-input class="consult_inp" placeholder="需求" type="textarea" v-model="form.demand"></el-input>
              </el-form-item>
              <el-button size="small" type="primary" @click="onSubmit">提 交</el-button>
            </el-form>
          </div>
        </div>

        <!--插入尾部-->
        <div>
          <keep-alive>
            <component  :is='components.tail1'></component>
          </keep-alive>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import header from '../components/header.vue'
import footer from '../components/footer.vue'
import {
  findBanner,
  findEnName,
  findSolutionOne,
  findSolutionTwo,
  findSolutionThree,
  findSolutionFour,
  findSolutionFive,
  addDemand
} from "@/api/zh"
// import {
//   selectCarouselPicture
// } from '../../api/auth'

export default {
  data () {
    return {
      tabId: null,
      components: {
        tail: header,
        tail1: footer
      },
      form: {
        name: '',
        phone: '',
        company: '',
        demand: ''
      },
      activeName: 'second',
      fit: 'cover',
      src: require('@assets/images/index/jiaguo.png'),
      src1: require('@assets/images/index/xiaotubiao.png'),
      url: require('@assets/images/index/tongdian.jpg'),
      url1: require('@assets/images/index/chanping1.png'),
      url2: require('@assets/images/index/changjing.jpg'),
      solutionList: [],
      carouselParams: {
        type: 1
      },
      enNameOne: '',
      enNameTwo: '',
      enNameThree: '',
      enNameFour: '',
      enNameFive: '',
      cnNameOne: '',
      cnNameTwo: '',
      cnNameThree: '',
      cnNameFour: '',
      cnNameFive: '',
      userPainPoints: [],
      schemeIntroduction: {
        id: null,
        fullPathUrl: '',
        title: '',
        content: ''
      },
      solutionArchitecture: {
        id: null,
        fullPathUrl: '',
        title: '',
        content: ''
      },
      solutionAdvantages: [],
      applicationScenarios: [],
      rules: {
        unitName: [{ required: true, message: '请输入单位', trigger: 'blur' }],
        fullName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入电话', trigger: 'blur' }],
        demand: [{ required: true, message: '请输入需求', trigger: 'blur' }]
      }
    }
  },
  created () {
    this.tabId = this.$route.query.tabId
    this.selectBanner()
    this.selectEnName()
  },
  mounted () {
  },
  methods: {
    jump (raw) {
      if (raw.newsId === undefined || raw.newsId === '' || raw.newsId === null) {
      } else {
        this.$router.push({
          path: '/textContent',
          query: {
            id: raw.newsId,
            type: 2
          }
        })
      }
    },
    /** 轮播图 */
    selectBanner () {
      let that = this
      findBanner(this.tabId).then(res => {
        that.solutionList = res.data
      })
    },
    /** 查询英文名称 */
    selectEnName () {
      let that = this
      findEnName(this.tabId).then(res => {
        let data = res.data
        that.enNameOne = data[0].enName
        that.cnNameOne = data[0].cnName
        that.selectSmartcityOne(data[0].id)

        that.enNameTwo = data[1].enName
        that.cnNameTwo = data[1].cnName
        that.selectSmartcityTwo(data[1].id)

        that.enNameThree = data[2].enName
        that.cnNameThree = data[2].cnName
        that.selectSmartcityThree(data[2].id)

        that.enNameFour = data[3].enName
        that.cnNameFour = data[3].cnName
        that.selectSmartcityFour(data[3].id)

        that.enNameFive = data[4].enName
        that.cnNameFive = data[4].cnName
        that.selectSmartcityFive(data[4].id)

      }).catch(error => {
        console.error('Error fetching English names:', error)
      })
    },

    async selectSmartcityOne (enNameId) {
      let that = this
      await findSolutionOne(enNameId).then(res => {
        that.userPainPoints = res.data
      }).catch(error => {
        console.error('Error fetching selectSmartcityOne:', error)
      })
    },
    async selectSmartcityTwo (enNameId) {
      let that = this
      await findSolutionTwo(enNameId).then(res => {
        that.schemeIntroduction = res.data != null ? res.data : that.schemeIntroduction
      }).catch(error => {
        console.error('Error fetching selectSmartcityTwo:', error)
      })
    },
    async selectSmartcityThree (enNameId) {
      let that = this
      await findSolutionThree(enNameId).then(res => {
        that.solutionArchitecture = res.data != null ? res.data : that.solutionArchitecture
      }).catch(error => {
        console.error('Error fetching selectSmartcityThree:', error)
      })
    },
    async selectSmartcityFour (enNameId) {
      let that = this
      await findSolutionFour(enNameId).then(res => {
        that.solutionAdvantages = res.data
      }).catch(error => {
        console.error('Error fetching selectSmartcityFour:', error)
      })
    },
    async selectSmartcityFive (enNameId) {
      let that = this
      await findSolutionFive(enNameId).then(res => {
        that.applicationScenarios = res.data
      }).catch(error => {
        console.error('Error fetching selectSmartcityFive:', error)
      })
    },
    /** tab */
    handleClick (tab, event) {
      console.log(tab, event)
    },
    onSubmit () {
      let that = this
      this.$refs.solutionRef.validate((valid) => {
        if (valid) {
          let params = that.form
          params.tabId = that.tabId
          addDemand(params).then(res => {
            that.$message({
              type: 'success',
              message: res.msg,
              duration: 1000
            })
            that.form = {}
          }).catch(error => {
            console.log('Error submitting form:', error)
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
::v-deep .htmlImgSize img{
  max-width: 100%;
  height: auto;
}
</style>
